<template>
  <!-- 輔導紀錄頁 -->
  <dir class="scrollable-container">
    <app-overlay-loading :loading="loading" />

    <v-toolbar
      :color="themeColor"
      flat>
      <span class="title">使用紀錄 (三個月內)</span>
    </v-toolbar>

    <v-data-table
      class="data-table"
      no-data-text="查無資料"
      :headers="headers"
      :items="history"
      :disable-initial-sort="true"
      hide-actions>
      <template slot="items" slot-scope="props">
        <td>{{props.item.targetName}}</td>
        <td>{{props.item.subjects}}</td>
        <td class="text-xs-right">{{props.item.duration}}</td>
        <td class="text-xs-right">{{props.item.date}}</td>
      </template>
    </v-data-table>
  </dir>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      history: [],
      loading: false,
      headers: [
        {
          text: '輔導老師',
          value: 'targetName',
          width: '200'
        },
        {
          text: '輔導科目',
          value: 'subject'
        },
        {
          text: '輔導時間',
          align: 'right',
          value: 'duration'
        },
        {
          text: '輔導日期',
          align: 'right',
          value: 'date'
        }
      ]
    };
  },

  async mounted() {
    this.loading = true;
    try {
      this.history = await this.getFudaoHistory();
    } catch (e) {
      // TODO show error
    } finally {
      this.loading = false;
    }
  },

  methods: {
    ...mapActions('fudao', {
      getFudaoHistory: 'getFudaoHistory'
    })
  }
};
</script>

<style lang="stylus" scoped>
.data-table {
  overflow: auto;
  flex-grow: 1;
}

.data-table >>> .v-table__overflow {
  overflow: initial;
}
</style>
